import { render, staticRenderFns } from "./ScrollLogos.vue?vue&type=template&id=245b3ce7&scoped=true"
import script from "./ScrollLogos.vue?vue&type=script&lang=js"
export * from "./ScrollLogos.vue?vue&type=script&lang=js"
import style0 from "./ScrollLogos.vue?vue&type=style&index=0&id=245b3ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b3ce7",
  null
  
)

export default component.exports